import React from "react";
import { HelpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function HelpButton({ onClick, variant = "desktop" }) {
  const { t } = useTranslation("help");

  if (variant === "mobile") {
    return (
      <button
        type="button"
        onClick={onClick}
        aria-label={t("ui.button_label")}
        data-testid="help-button-mobile"
        className="w-9 h-9 grid place-items-center rounded-md hover:bg-white/10 text-white"
      >
        <HelpCircle size={18} />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="help-button-desktop"
      className="fixed bottom-5 right-5 z-20 hidden lg:flex items-center gap-2 px-3.5 py-2.5 rounded-full bg-qenva-navy text-white text-sm font-medium shadow-lg hover:bg-qenva-navy/90 transition-colors"
    >
      <HelpCircle size={16} />
      {t("ui.button_label")}
    </button>
  );
}
